import { VennDashboardParams } from './venn-dashboard.component';

export const VENN_DASHBOARD_DEFAULT: VennDashboardParams = {
  sets: ['A', 'B'],
  labelU: 'U',
  initialIndex: 0,
};

export const VENN_DASHBOARD_CUSTOM_LABELS: VennDashboardParams = {
  sets: ['P', 'Q'],
  labelU: 'S',
  initialIndex: 0,
};

export const VENN_DASHBOARD_NO_SELECTION: VennDashboardParams = {
  sets: ['A', 'B'],
  labelU: 'U',
  initialIndex: null,
};

export const VENN_DASHBOARD_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: VENN_DASHBOARD_DEFAULT },
  'custom-labels': { params: VENN_DASHBOARD_CUSTOM_LABELS },
  'no-selection': { params: VENN_DASHBOARD_NO_SELECTION },
};
